import React, { useState } from "react";
import * as pdfjsLib from "pdfjs-dist";

// Use CDN worker for compatibility with modern pdfjs-dist
pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

export default function PdfTextExtractor() {
  const [text, setText] = useState("");
  const [error, setError] = useState("");

  const handleFileChange = async (e) => {
    setText("");
    setError("");
    const file = e.target.files[0];
    if (!file) return;

    try {
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      let fullText = "";
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join(" ");
        fullText += pageText + "\n";
      }
      setText(fullText.trim());
    } catch (err) {
      setError("Could not extract text from PDF (only works for digital PDFs).");
    }
  };

  const fileInputRef = React.useRef();

  return (
    <div>
      <button
        type="button"
        onClick={() => fileInputRef.current && fileInputRef.current.click()}
        style={{ padding: "10px 20px", fontSize: 16, cursor: "pointer", marginBottom: 16 }}
      >
        Select PDF
      </button>
      <input
        type="file"
        accept="application/pdf"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      {error && <div style={{ color: "red" }}>{error}</div>}
      <textarea
        rows={15}
        cols={80}
        value={text}
        readOnly
        placeholder="Extracted text will appear here..."
        style={{ marginTop: 10, width: "100%" }}
      />
    </div>
  );
}
